function getStorage(name) {
    let data = localStorage.getItem(name);
    if (data) {
        return JSON.parse(data)
    }
    return data
}
function setStorage(name, data) {
    let d = JSON.stringify(data)
    localStorage.setItem(name, d);
}
function delStorage(name) {
    localStorage.removeItem(name);
}

export default {
    getStorage,
    setStorage,
    delStorage,
}
